<template>
  <div class="employee">
    <ProjectLayout/>
    <CCard class="card-table-emloyee">
      <div>
        <h3 class="font-weight-bold">Tìm kiếm</h3>
      </div>
      <CRow>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("project.label_project_name") }}</label>
          </div>
        </CCol>
        <CCol sm="4">
          <CInput
            v-model="searchData.name"
            :placeholder="this.$t('placeholder.label_project_name')"
            v-on:keyup.enter="search"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("project.label_project_status") }}</label>
          </div>
        </CCol>
        <CCol sm="3">
          <select
            v-model="searchData.status"
            class="form-control"
            @change="search"
          >
            <option value="0">
              {{ $t("placeholder.label_employee_option_search") }}
            </option>
            <option
              v-for="(item, index) in project_status"
              v-show="
                item.parent_code === searchData.footCode ||
                  searchData.footCode === 0
              "
              :key="index"
              :value="item.code"
            >{{ item.text }}
            </option>
          </select>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("project.label_project_type") }}</label>
          </div>
        </CCol>
        <CCol sm="3">
          <select
            v-model="searchData.project_type"
            class="form-control"
            @change="search"
          >
            <option value="0">
              {{ $t("placeholder.label_employee_option_search") }}
            </option>
            <option
              v-for="(item, index) in listProjectType"
              v-show="true"
              :key="index"
              :value="item"
            >{{ item.text }}
            </option>
          </select>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("project.label_project_department_code") }}</label>
          </div>
        </CCol>
        <CCol sm="3">
          <select
            v-model="searchData.department_code"
            class="form-control"
            @change="search"
          >
            <option value="0">
              {{ $t("placeholder.label_employee_option_search") }}
            </option>
            <option
              v-for="(item, index) in departments"
              v-show="true"
              :key="index"
              :value="item.id"
            >{{ item.text }}
            </option>
          </select>
        </CCol>
      </CRow>
      <CRow>
        <CCol class="text-center btn-search" sm="12">
          <CButton class="btn-search-employee" @click.prevent="search">
            {{ $t("button.label_employee_btn_search") }}
          </CButton>
          <CButton class="btn-reset" @click="resetForm">{{
              $t("button.label_action_reset")
            }}
          </CButton>
        </CCol>
      </CRow>
    </CCard>
    <CRow>
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody>
            <CRow class="justify-content-end p-2 mb-md-0 mb-3">
              <CButton color="info mr-3" @click="showModal">{{ $t("project.create_project") }}</CButton>
            </CRow>
            <div class="table-responsive">
              <table class="table table-mobile table-tablet">
                <thead>
                <tr>
                  <th scope="col">
                    STT
                  </th>
                  <th scope="col">
                    {{ $t("project.label_project_name") }}
                  </th>
                  <th scope="col">
                    {{ $t("project.customer") }}
                  </th>
                  <th class="h-width" scope="col">
                    {{ $t("project.label_project_type") }}
                  </th>
                  <th scope="col" style="width: 140px;">
                    {{ $t("project.label_project_status") }}
                  </th>
                  <!--                    <th scope="col" style="width: 140px;">-->
                  <!--                      {{ $t("project.label_project_overview") }}-->
                  <!--                    </th>-->
                  <th class="h-width" scope="col" style="width: 150px;">
                    {{ $t("project.label_project_department_code") }}
                  </th>
                  <!--                    <th scope="col" class="h-width">-->
                  <!--                      {{ $t("project.contract_value") }}-->
                  <!--                    </th>-->
                  <th scope="col" style="width: 150px;">
                    {{ $t("project.label_project_list_start_date") }}
                  </th>
                  <th scope="col" style="width: 150px;">
                    {{ $t("project.label_project_list_end_date") }}
                  </th>
                  <th scope="col" style="width: 150px; text-align: center">
                    {{ $t("employee.label_employee_action") }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <template v-if="projects && projects.length > 0">
                  <tr v-for="(item, index) in listProjects" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">{{ item.name }}</td>
                    <td class="text-center">
                      {{ item.customers ? item.customers.abbreviations : "" }}
                    </td>
                    <td class="text-center">{{ getProjectType(parseInt(item.project_type)) }}</td>
                    <td class="text-center">
                      {{
                        item.project_status ? item.project_status.name : ""
                      }}
                    </td>
                    <!--                      <td class="text-center">{{ item.project_overview ? getOverview(item.project_overview) : null }}</td>-->
                    <td class="text-center">{{ item.department_name }}</td>
                    <!--                      <td class="text-center">{{ item.contract_value }}</td>-->
                    <td class="text-center">{{ item.start_date }}</td>
                    <td class="text-center">{{ item.end_date }}</td>
                    <td
                      class="py-2 d-flex justify-content-center"
                      style="width: 180px"
                    >
                      <span class="mr-1"></span>
                      <router-link
                        :to="{
                            name: 'projects.detail',
                            params: { id: item.id }
                          }"
                        tag="a"
                      >
                        <CButton
                          color="primary"
                          size="sm"
                          square
                          variant="outline"
                        >
                          {{ $t("button.label_action_detail") }}
                        </CButton>
                      </router-link>
                      <span class="mr-1"></span>
                      <router-link
                        :to="{ name: 'projects.edit', params: { id: item.id } }"
                        tag="a"
                      >
                        <CButton
                          color="info"
                          size="sm"
                          square
                          variant="outline"
                        >
                          {{ $t("button.label_action_update") }}
                        </CButton>
                      </router-link>
                      <span class="mr-1"></span>
                      <CButton
                        color="danger"
                        size="sm"
                        square
                        variant="outline"
                        @click="deleteProject(item)"
                      >
                        {{ $t("button.label_action_delete") }}
                      </CButton>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td class="text-center" colspan="12">
                      {{ $t("table.label_data_not_found") }}
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <b-modal ref="my-modal" hide-footer hide-header ignore-enforce-focus-selector=".select2-search__field">
      <div class="title-modal-wrapper">
        <h5 class="info mt-2">
          {{ $t("project.create_project") }}
        </h5>
        <div>
          <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg"
               @click="hideModal">
            <path
              d="M17.4856 0.290709L17.6041 0.39587C17.8383 0.630061 17.9783 0.942035 17.9977 1.27262C18.0171 1.6032 17.9144 1.9294 17.7093 2.18935L17.6041 2.3079L10.912 9L17.6041 15.6921C17.8383 15.9263 17.9783 16.2383 17.9977 16.5689C18.0171 16.8994 17.9144 17.2256 17.7093 17.4856L17.6041 17.6041C17.3699 17.8383 17.058 17.9783 16.7274 17.9977C16.3968 18.0171 16.0706 17.9144 15.8106 17.7093L15.6921 17.6041L9 10.912L2.3079 17.6041C2.07371 17.8383 1.76173 17.9783 1.43115 17.9977C1.10057 18.0171 0.774363 17.9144 0.514415 17.7093L0.39587 17.6041C0.161741 17.3699 0.0217041 17.058 0.00232013 16.7274C-0.0170638 16.3968 0.0855526 16.0706 0.290707 15.8106L0.39587 15.6921L7.08797 9L0.39587 2.3079C0.161741 2.07371 0.0217036 1.76173 0.00231968 1.43115C-0.0170643 1.10057 0.0855535 0.774364 0.290708 0.514415L0.39587 0.39587C0.63006 0.161741 0.942035 0.0217036 1.27262 0.00231968C1.6032 -0.0170642 1.9294 0.0855532 2.18935 0.290708L2.3079 0.39587L9 7.08797L15.6921 0.39587C15.9263 0.161741 16.2383 0.0217038 16.5688 0.00231991C16.8994 -0.017064 17.2256 0.0855537 17.4856 0.290709Z"
              fill="#303C54"/>
          </svg>
        </div>
      </div>
      <div class="content-modal-wrapper">
        <ValidationObserver ref="formCreateProject" tag="form">
          <CForm class="create_form" @submit.prevent="handleSubmit">
            <!-- 1. Tên dự án -->
            <CRow class="info-value mt-2">
              <CCol class="form-field" md="12">
                <label>{{ $t("project.name_project") }}</label>
                <span class="require"> *</span>
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('project.name_project')"
                  mode="passive"
                  rules="required"
                >
                  <input v-model="form.name" :placeholder="$t('placeholder.label_project_name')" class="form-control"/>
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
            </CRow>
            <!-- 2. Khách hàng -->
            <CRow class="info-value mt-4">
              <CCol class="form-field" md="12">
                <label>{{ $t("project.customer") }}</label>
                <Select2
                  v-model="form.customer"
                  :options="customers"
                  :placeholder="$t('placeholder.label_option')"
                  class="select2-custom"
                />
              </CCol>
            </CRow>
            <!-- 3. Thị trường -->
            <CRow class="info-value mt-4">
              <CCol class="form-field" md="12">
                <label>{{ $t("project.market") }}</label>
                <Select2
                  v-model="form.market"
                  :options="markets"
                  :placeholder="$t('placeholder.label_option')"
                  class="select2-custom"
                />
              </CCol>
            </CRow>
            <!-- 4. Khối phát triển -->
            <CRow class="info-value mt-4">
              <CCol class="form-field" md="12">
                <label>{{ $t("project.label_project_department_code") }}</label>
                <Select2
                  v-model="form.department"
                  :options="departments"
                  :placeholder="$t('placeholder.label_option')"
                  class="select2-custom"
                />
              </CCol>
            </CRow>
            <!-- 5. Loại dự án -->
            <CRow class="info-value mt-4">
              <CCol class="form-field" md="12">
                <label>{{ $t("project.project_type") }}</label>
                <Select2
                  v-model="form.type"
                  :options="listProjectType"
                  :placeholder="$t('placeholder.label_option')"
                  class="select2-custom"
                />
              </CCol>
            </CRow>
            <!-- 6. Giá trị hợp đồng -->
            <CRow class="info-value mt-4">
              <CCol class="form-field" md="12">
                <label>{{ $t("project.contract_value") }}</label>
                <input
                  v-model="form.contract_value"
                  type="number"
                  min="0"
                  step="0.01"
                  :placeholder="$t('placeholder.label_contract_value')"
                  class="form-control"
                />
              </CCol>
            </CRow>
            <!-- 7. Thời gian triển khai -->
            <CRow class="info-value mt-4">
              <CCol class="form-field" md="12">
                <label>{{ $t("project.start_date") }}</label>
                <input
                  v-model="form.start_date"
                  type="date"
                  class="form-control"
                />
              </CCol>
            </CRow>
            <!-- 8. Thời gian bàn giao -->
            <CRow class="info-value mt-4">
              <CCol class="form-field" md="12">
                <label>{{ $t("project.end_date") }}</label>
                <input
                  v-model="form.end_date"
                  type="date"
                  class="form-control"
                />
              </CCol>
            </CRow>
            <!-- 9. Trạng thái -->
            <CRow class="info-value mt-4 mb-4">
              <CCol class="form-field" md="12">
                <label>{{ $t("project.status") }}</label>
                <Select2
                  v-model="form.status"
                  :options="status"
                  :placeholder="$t('placeholder.label_option')"
                  class="select2-custom"
                />
              </CCol>
            </CRow>
            <div class="btn-submit d-flex justify-content-center mb-2">
              <b-button
                class="btn-save mr-3"
                @click.prevent="handleSubmit"
              >{{ $t("button.label_action_accept") }}
              </b-button
              >
              <b-button class="btn-cancel" @click="hideModal">{{
                  $t("seat_employee.button.cancel_seat_employee")
                }}
              </b-button>
            </div>
          </CForm>
        </ValidationObserver>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "axios";
import api from "../../api/api.js";
import ProjectLayout from "./ProjectLayout";

export default {
  name: "CustomerIndex",
  metaInfo() {
    return {
      title: this.$t("page_title.page_project_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ProjectLayout
  },
  data() {
    let paramsLocal = localStorage.project_search_params
      ? JSON.parse(localStorage.project_search_params)
      : [];
    return {
      listProjects: [],
      searchData: {
        name: paramsLocal.name ?? "",
        status: paramsLocal.status ?? "DOING",
        project_type: paramsLocal.project_type ?? 0,
        department_code: paramsLocal.department_code ?? 0,
        department_test: paramsLocal.department_test ?? 0
      },
      form: {
        name: '',
        customer: '',
        market: '',
        department: '',
        type: '',
        contract_value: '',
        start_date: '',
        end_date: '',
        status: '',
      },
      markets: [
        { id: 'DOMESTIC', text: 'Nội địa' },
        { id: 'JAPAN', text: 'Nhật Bản' },
        { id: 'USA', text: 'Mỹ' },
        { id: 'EU', text: 'Châu Âu' },
        { id: 'OTHER', text: 'Khác' }
      ],
      status: [
        {
          id: "TODO",
          text: "Sắp triển khai"
        },
        {
          id: "DOING",
          text: "Đang triển khai"
        },
        {
          id: "DONE",
          text: "Đã hoàn thành"
        }
      ],
      listProjectType: [
        {
          id: 1,
          text: "SPOT"
        },
        {
          id: 2,
          text: "LABO"
        },
        {
          id: 3,
          text: "MAINTAIN"
        },
        {
          id: 4,
          text: "OTHER"
        },
      ]
    };
  },
  computed: {
    ...mapGetters({
      projects: "project/projects",
      listItemsPerPage: "commons/listItemsPerPage",
      pagination: "project/pagination",
      getEmployees: "project/getEmployees",
      foots: "commons/foots",
      developDivisions: "commons/developDivisions",
      qualityDivisions: "commons/qualityDivisions",
      parentDevelopDivistions: "commons/parentDevelopDivistions",
      project_status: "project/project_status",
      customers: "project/customers"
    }),
    departments() {
      return this.parentDevelopDivistions.map((item) => {
        item.id = item.code;
        return item;
      });
    }
  },
  methods: {
    ...mapActions("project", [
      "fetchProject",
      "delete",
      "getEmployeeAll",
      "getCommonsData"
    ]),
    ...mapActions("layout", ["setLoading"]),

    startDate(data) {
      this.searchData.start_date = data;
    },

    endDate(data) {
      this.searchData.end_date = data;
    },

    showModal() {
      this.$refs["my-modal"].show();
    },

    hideModal() {
      this.form = {
        name: '',
        customer: '',
        market: '',
        department: '',
        type: '',
        contract_value: '',
        start_date: '',
        end_date: '',
        status: '',
      }
      this.$refs["my-modal"].hide();
    },

    getProjectType(type) {
      switch (type) {
        case 1:
          return 'SPOT';
        case 2:
          return 'LABO';
        case 3:
          return 'MAINTAIN';
        case 4:
          return 'OTHER';
        default:
          return '';
      }
    },

    getOverview(overview) {
      switch (overview) {
        case 3:
          return this.$t("project.overview.bad");
        case 2:
          return this.$t("project.overview.medium");
        default:
          return this.$t("project.overview.good");
      }
    },

    async handleSubmit() {
      const isValid = await this.$refs.formCreateProject.validate();
      if (!isValid) {
        return;
      }
      this.setLoading(true);
      this.$store.dispatch("project/createProject", {
        name: this.form.name,
        customer_id: this.form.customer,
        market: this.form.market,
        department_code: this.form.department,
        project_type: this.form.type,
        contract_value: this.form.contract_value,
        start_date: this.form.start_date,
        end_date: this.form.end_date,
        status: this.form.status
      }).then(() => {
        this.$toast(
          this.$t("employee.message_create_success"),
          this.$t("popup.label_popup_success"),
          2000,
          "b-toaster-top-center",
          "success"
        );
        this.fetchProjectData();
        this.hideModal();
      });
      this.setLoading(false);
    },

    getDateSearch() {
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      let firstDay = "";
      if (
        moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
          "YYYY-MM-DD"
        ) <= currentDay &&
        currentDay <=
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      }
      if (
        currentDay >
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      }
      return {
        firstDay: Intl.DateTimeFormat("en-GB").format(firstDay),
        lastDay: ""
      };
    },

    getNumberRow(data, index) {
      return (data.current_page - 1) * data.per_page + index + 1;
    },

    resetForm() {
      this.searchData.name = "";
      this.searchData.status = "DOING";
      this.searchData.project_type = 0;
      this.searchData.department_code = 0;
      this.searchData.department_test = 0;
      localStorage.project_search_params = JSON.stringify(this.searchData);
    },

    async fetchProjectData() {
      localStorage.project_search_params = JSON.stringify(this.searchData);
      await this.fetchProject({
        name: this.searchData.name.toLowerCase(),
        status: this.searchData.status,
        project_type: this.searchData.project_type.id,
        department_test: this.searchData.department_test,
        department_code: this.searchData.department_code
      });
      this.listProjects = this.projects;
    },
    async getEmployeesData() {
      this.getEmployeeAll();
    },
    async search() {
      this.setLoading(true);
      try {
        await this.fetchProjectData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },
    changePage(page) {
      this.fetchProjectData(this.searchData.itemsPerPage, page);
    },
    async deleteProject(project) {
      this.$confirm(
        this.$t("popup.label_popup_text"),
        `${this.$t("commons.label_delete")} ${project.name}`,
        this.$t("popup.label_confirm_button"),
        this.$t("popup.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.delete(project.id)
            .then(() => {
              this.fetchProjectData();
              this.$toast(
                this.$t("popup.label_popup_success_text"),
                null,
                2000,
                "b-toaster-top-center",
                "success"
              );
            })
            .catch(() => {
              this.$toast(
                this.$t("popup.label_popup_error_text"),
                null,
                2000,
                "b-toaster-top-center",
                "error"
              );
            });
        }
      });
    }
  },
  created() {
    this.searchData.start_date = this.getDateSearch().firstDay;
    this.searchData.end_date = this.getDateSearch().lastDay;
    this.getEmployeesData();
    this.fetchProjectData();
    this.getCommonsData();
  }
};
</script>

<style lang="scss" scoped>
.employee {
  margin: -2rem -2rem 2rem -2rem;

  .card-table-emloyee {
    padding: 30px;
    border-top-color: #EFEFEF;

    .select2-container--default {
      // .select2-selection--single {
      border: 1px solid !important;
      color: #e4e6ea !important;
      border-radius: 4px !important;
    }
  }

  .btn-search-employee {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
  }

  .employee-table {
    margin: 0 20px 0 30px;
  }

  .select-per-page {
    width: 70px;
  }

  .option-table {
    display: flex;
    justify-content: space-between;
  }
}

/deep/ .modal-dialog {
  max-width: 691px;
}

/deep/ .modal-body {
  padding: 0px;

  .title-modal-wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #d8dbe0;

    .info {
      padding: 1rem;
      color: #1f2d3d;
      font-weight: 500;
    }

    div {
      padding: 1rem;
      margin-right: 10px;

      svg {
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }

  .content-modal-wrapper {
    padding: 1rem;

    .form-field {
      label {
        color: #303C54;
        font-weight: 500;
      }

      input {
        height: 40px;
      }

      .require {
        color: #ff1a1a;
      }
    }
  }
}

.required {
  color: #ff1a1a;
}
</style>
<style scoped>
table .h-width {
  width: 60px;
}

table .btn {
  min-width: max-content;
}

table th {
  text-align: center;
  vertical-align: middle;
}

.select2-custom .select2-selection {
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  height: calc(1.5em + 0.75rem + 2px);
  display: block;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #d8dbe0;
  color: #768192;
  background-color: #fff;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select2-custom .select2-selection:focus {
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}

ul {
  list-style-type: none;
}

.pagination {
  display: flex;
  list-style: none;
  border-radius: 0.25rem;
  margin-bottom: 10px;
}

@media only screen and (max-device-width: 480px) {
  .employee-table {
    margin: 0 20px !important;
  }

  .show-text-table {
    margin-top: 0.4rem;
  }

  .btn-search {
    margin-top: 15px;
  }
}

@media only screen and (max-device-width: 767px) {
  .card-body {
    padding: 0.5rem;
  }

  .btn-search {
    margin-top: 15px;
  }

  .table-mobile {
    width: 1200px;
    overflow-x: scroll;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-tablet {
    width: 1200px;
    overflow-x: scroll;
  }
}
</style>
<style lang="scss">
@media only screen and (max-device-width: 767px) {
  span.select2.select2-container.select2-container--default {
    width: 100% !important;
  }
}

.btn-submit {
  .btn-save {
    background: #118FA6;
    color: #EBF3F4;
  }

  .btn-cancel {
    background: #FFFFFF;
    color: #1F2D3D;
  }

  button {
    width: 172px;
    height: 49px;
    font-weight: 500;
  }
}

.select2-custom {
  .select2-selection {
    font-size: 0.875rem;
    font-weight: 400;
    // padding: 0.375rem 0.75rem;
    height: 40px;
    display: block;
    background-clip: padding-box;
    border: 1px solid #d8dbe0;
    color: #768192;
    background-color: #fff;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    .select2-selection__rendered {
      height: 40px;
      padding-top: 5px;
    }

    .select2-selection__arrow {
      height: 40px;
      padding: 4px 8px;
      width: 40px;
    }
  }

  .select2-selection:focus {
    color: #768192;
    background-color: #fff;
    border-color: #958bef;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
  }
}

.select2-search__field {
  border-radius: 5px;
}

.select2-container {
  width: 100% !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
